import React from 'react'
import './SlicedCircle.css'

export default function SlicedCircle({ percentage }) {

  // Orange - 25 - 49
  // Yellow - 50 - 60
  // Green - 70 + 

  // convert percentage to degrees (360 degrees = 100%)
  percentage = parseInt(percentage);
  const sliceDegree = percentage * 3.6;

  let color = "#eb8634";
  let className = "low";

  if(percentage < 25){
    color = '#eb8634'; // orange
    className = "low"; 
  }else if(percentage >= 25 && percentage < 50){
    color = '#eb8634'; // orange
    className = "low";
  }else if(percentage >= 50 && percentage < 70){
    color = '#e3b716';  // yellow
    className = "mid";
  }else if(percentage >= 70){
    color = '#6ABB88'; // green
    className = "high";
  }

  return (
    <span className={`sliced_circle_parent ${className}`}>
    <span
      className={`sliced_circle ${className}`}
      style={{
        background: `conic-gradient(${color} ${sliceDegree}deg, transparent 0deg)`,
      }}
    > {" "}
    </span>
    </span>
  );
};